export const isBeforeNineRome = (now = new Date()) => {
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/Rome',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  }).formatToParts(now);
  const hour = Number(parts.find((part) => part.type === 'hour')?.value ?? '0');
  return hour < 9;
};

export const formatValidationSentence = (
  name?: string | null,
  surname?: string | null,
  validatedAt?: string | null
) => {
  const who = `${name || ''} ${surname || ''}`.trim();
  if (!who || !validatedAt) {
    return null;
  }
  const date = new Date(validatedAt);
  if (Number.isNaN(date.getTime())) {
    return null;
  }
  const formatted = date.toLocaleDateString('it-IT', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
  return `${who} ha convalidato il ${formatted}`;
};
